import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';

export type ColumnsOptions = {
  type: EntityBase[];
};

export const useColumns = ({ onEdit }: { onEdit: (status: EntityBase & { is_active: boolean }) => void }) => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'is_active',
      label: 'Активен',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: boolean) => <span>{value ? 'Да' : 'Нет'}</span>,
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(rowData as EntityBase & { is_active: boolean })} aria-label="edit">
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    }
  ] as TableColumn[];
};
